var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRalvieLogoWithoutName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.342,
    height: 39.625,
    viewBox: "0 0 34.342 39.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.977,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9c2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#814d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d0b77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ralvie_Logo",
    "data-name": "ralvie Logo",
    transform: "translate(-407.178 -362.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_105",
    "data-name": "Subtraction 105",
    d: "M17.171,39.625h0Zm-1.36-.053h0a17.011,17.011,0,0,1-6.2-1.7A17.181,17.181,0,0,1,1.316,15.849H11.888a3.962,3.962,0,1,1,0,7.925H4.321l2.438,3.353,1.4,1.931L15.81,39.572Zm5.035-.341h0L13.362,28.942a9.246,9.246,0,0,0-1.474-18.375H4.78A17.2,17.2,0,0,1,10.321,6.7a17.041,17.041,0,0,1,3.3-1.053,17.329,17.329,0,0,1,7.011-.019,17.074,17.074,0,0,1,6.14,2.584,17.223,17.223,0,0,1,6.221,7.555,17.063,17.063,0,0,1,1,3.223A17.185,17.185,0,0,1,26.21,37.056a17.036,17.036,0,0,1-5.364,2.175ZM19.152,3.963H15.189A1.981,1.981,0,0,1,13.788.58a1.968,1.968,0,0,1,1.4-.58h3.963a1.981,1.981,0,0,1,1.4,3.382A1.967,1.967,0,0,1,19.152,3.963Z",
    transform: "translate(407.178 362.997)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalvieLogoWithoutName);
export default __webpack_public_path__ + "static/media/ralvie_logo_without_name.f3ee0f0390b5cefd88fd485323750fe7.svg";
export { ForwardRef as ReactComponent };